/**
 * Filter function used to filter out statuses in Comms management page.
 */
(function() {
    'use strict';

    angular.module('app').filter('xmsTypeFilter', function() {

        return function(input, xmsTypes) {
            if (!xmsTypes || xmsTypes.length === 0) return input;
            var out = [];
            angular.forEach(input, function (item) {
                angular.forEach(xmsTypes, function (xmsType) {
                    if(item.xmsType){
                        if (item.xmsType === xmsType.type) {
                            out.push(item);
                        }
                    }
                });
            });
            return out;
        }
    });

}());